// src/hooks/useTheme.js

import { useState, useEffect } from 'react';

const STORAGE_KEY = 'auditpro_theme';

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    // 1. Respect saved preference
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
    // 2. Fall back to OS preference
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  });

  useEffect(() => {
    const root = document.documentElement;

    // Lock transitions for one frame so newly mounted components
    // don't animate from the wrong theme colour on page navigation
    root.setAttribute('data-theme-switching', 'true');
    root.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);

    const raf = requestAnimationFrame(() => {
      root.removeAttribute('data-theme-switching');
    });

    return () => cancelAnimationFrame(raf);
  }, [theme]);

  // Accept an explicit value or toggle if none given
  const toggleTheme = (next) =>
    setTheme(next ?? (theme === 'dark' ? 'light' : 'dark'));

  return { theme, toggleTheme };
}